import React from "react";
import { Route, Link } from "react-router-dom";

const SubitemSidebar = ({ to, ...rest }) => (
    <Route
        path={to}
        exact
        children={({ match }) => (
            <Link to={to} {...rest} className={match ? "side-item active" : "side-item"} />
        )}
    />
);

export default SubitemSidebar;




// WEBPACK FOOTER //
// ./src/modules/comum/components/SubitemSidebar.js